import { RangeEntryWrapper } from '../../Types'

/**
 * Sorts range entry wrappers.
 * Excluded values are always at the end of the list.
 * String values are sorted alphabetically. Towards the start of the list.
 * Number values are sorted numerically. Towards the start of the list.
 *
 * @param a - The first range entry wrapper to compare.
 * @param b - The second range entry wrapper to compare.
 *
 * @returns - The sort order of the range entry wrappers.
 */
export const sortRangeEntryWrappers = (a: RangeEntryWrapper, b: RangeEntryWrapper): number => {
    const aSortValue: number | string = a.isRange ? a.value.min : a.value
    const bSortValue: number | string = b.isRange ? b.value.min : b.value

    // Excluded values are always at the end of the list
    if (a.included && !b.included) {
        return -1
    }

    if (!a.included && b.included) {
        return 1
    }

    // Range values are always at the start of the list
    if (a.isRange && !b.isRange) {
        return -1
    }

    if (!a.isRange && b.isRange) {
        return 1
    }

    // Sort number values before string values
    if (typeof aSortValue === 'string' && typeof bSortValue === 'number') {
        return -1
    }

    if (typeof aSortValue === 'number' && typeof bSortValue === 'string') {
        return 1
    }

    // Sort number values numerically and string values alphabetically
    if (typeof aSortValue === 'number' && typeof bSortValue === 'number') {
        return aSortValue - bSortValue
    }

    if (typeof aSortValue === 'string' && typeof bSortValue === 'string') {
        return aSortValue.localeCompare(bSortValue)
    }

    return 0
}
